module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Rectangle_806@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FRectangle_806%402x.png
// module id = jd3k
// module chunks = 93